import React from 'react';
import { ComingSoon } from '../../components/ComingSoon';

const ReservationAttempts = () => {
  return (
    <ComingSoon heading="Reservation Attempts">
      <div className="text-sm text-gray-500 font-medium mt-4">🚧 Coming Soon Feature</div>
    </ComingSoon>
  );
};

export default ReservationAttempts;